import React from 'react';
import { Smile, Meh } from 'lucide-react';

interface StatusBadgeProps {
  status?: 'satisfatorio' | 'atencao';
  score?: number;
  className?: string;
}

// Define cores e informações para diferentes status
const getStatusInfo = (score?: number) => {
  // Se status não foi fornecido, calcular baseado no score
  let currentStatus = 'atencao';
  if (!currentStatus && score !== undefined) {
    if (score > 0) {
      currentStatus = 'atencao';
    } else {
      currentStatus = 'satisfatorio';
    }
  }

  switch (currentStatus) {
    case 'satisfatorio':
      return {
        text: 'text-green-700',
        background: 'bg-green-100',
        border: 'border-green-200',
        Icon: Smile,
        label: 'Satisfatório',
      };
    case 'atencao':
    default:
      return {
        text: 'text-yellow-700',
        background: 'bg-yellow-100',
        border: 'border-yellow-200',
        Icon: Meh,
        label: 'Atenção',
      };
  }
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ score, className = '' }) => {
  const { text, background, border, Icon, label } = getStatusInfo(score);
  
  return (
    <div
      className={`flex items-center justify-center rounded-full font-bold text-lg border-2 px-4 py-2 ${text} ${background} ${border} ${className}`}
      title={`Status: ${label}`}
    >
      <Icon className="w-6 h-6 mr-2" />
      <span className="text-base font-medium">{label}</span>
    </div>
  );
};

export default StatusBadge; 